import axios from "axios";

export class UpdateRepository {

	constructor() {
		this.axios = axios.create({
			baseURL: process.env.REACT_APP_BASE_URL,
			timeout: 30000,
		});
	}

	async create(formData) {
		return await this.axios.post("admin/atualizacoes", formData, {
			headers: {
				"Content-Type": "multipart/form-data",
				Authorization: `Bearer ${localStorage.getItem("access_token")}`
			},
		});
	}

	async fetchHistory() {
		return await this.axios.get("admin/atualizacoes/historico", {
			headers: {
				Authorization: `Bearer ${localStorage.getItem("access_token")}`
			},
		});
	}

	async fetchRecentsUser() {
		const dominio = window.location.host;
		return await this.axios.get(`atualizacoes/historico?dominio=${dominio}`, 
			{ 
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`
				},}
		);
	}

	async toggleStatus(id) {
		return await this.axios.patch(`admin/atualizacoes/${id}/status`, {}, {
			headers: {
				Authorization: `Bearer ${localStorage.getItem("access_token")}`
			},
		});
	}

	async fetchPending(usuarioId, dominio) {
		return await this.axios.get(`atualizacoes/pendentes/${usuarioId}?dominio=${dominio}`, { 
			headers: {
				Authorization: `Bearer ${localStorage.getItem("access_token")}`
			},}
		);
	}

	async markAsRead(atualizacaoId, usuarioId, dominio) {
		return await this.axios.post(`atualizacoes/${atualizacaoId}/ler`, { 
			usuarioId: usuarioId},
		{
			params: {
        		dominio: dominio,
      		},
			headers: {
				Authorization: `Bearer ${localStorage.getItem("access_token")}`
			}, 
		});
	}
}  